import React       from 'react';
import ReactDom    from 'react-dom';
import Utils       from 'utils';

import ContentsModal from 'contents_modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class InputManagement extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal       : false,
      select_id   : null,
      select_list : [],
    }
  }
  // -------------------------------------------------------
  
  openModal() {
    let ids = this.getDefaultValue.bind(this)();
    this.setState({ modal: true, select_id: null, select_list: ids });
  }
  // -------------------------------------------------------
  
  closeModal() {
    this.setState({ modal: false, select_id: null, select_list: [] });
  }
  // -------------------------------------------------------
  
  change() {
    this.setState({ select_id: this.item.value });
  }
  // -------------------------------------------------------
  
  select() {
    let select_list = this.state.select_list;
    if( select_list.indexOf(this.item.value) == -1 && this.item.value != 'null' ) select_list.push(parseInt(this.item.value));
    this.setState({ select_list: select_list });
    
    setTimeout( function(){ this.change.bind(this)(); }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  remove(item_id) {
    let select_list = this.state.select_list.filter((id) => { if( id != item_id ) return id; });
    this.setState({ select_list: select_list });
  }
  // -------------------------------------------------------
  
  update() {
    this.props.update_ev.bind(this)(this.state.select_list.join());
    this.closeModal.bind(this)();
  }
  // -------------------------------------------------------
  
  notice_toggle(user_id) {
    user_id = String(user_id);
    
    let notice = [];
    try { notice = this.props.update.notice.split(','); } catch(e) {}
    
    if( notice.indexOf(user_id) == -1 ){
      notice.push(user_id);
    } else {
      notice = notice.filter((id) => { if( id != user_id ) return id; });
    }
    
    notice = notice.filter((id) => { if( id != '' ) return id; });
    this.props.update_ev.bind(this)(notice.join(), 'notice');
  }
  // -------------------------------------------------------
  
  action_client_toggle(user_id) {
    user_id = String(user_id);
    
    let action_client = [];
    try { action_client = this.props.update.action_client.split(','); } catch(e) {}
    
    if( action_client.indexOf(user_id) == -1 ){
      action_client.push(user_id);
    } else {
      action_client = action_client.filter((id) => { if( id != user_id ) return id; });
    }
    
    action_client = action_client.filter((id) => { if( id != '' ) return id; });
    this.props.update_ev.bind(this)(action_client.join(), 'action_client');
  }
  // -------------------------------------------------------
  
  getDefaultValue() {
    try {
      let list = this.props.data.default.split(',').filter((t) => { if( t != '' ) return t; });
      return list.map((id) => { return parseInt(id); });
    } catch(e) {
      return []
    }
  }
  // -------------------------------------------------------
  
  getTargets() {
    let data = this.props.data;
    let base = this.props.base;
    
    let targets = [];
    if( data.id == 'management_company' ){
      base.management.guest_companys.map((d) => {
        if( this.state.select_list.indexOf(d.id) == -1 ) targets.push(d);
      });
    } else {
      
      // 管理者・ユーザーはどちらかのみ
      let skip_list = [];
      if( data.id == 'management_user'  ) try { skip_list = this.props.update.management_admin.split(',').map((id) => { return parseInt(id); }); } catch(e) {}
      if( data.id == 'management_admin' ) try { skip_list = this.props.update.management_user.split(',').map((id) => { return parseInt(id); }); } catch(e) {}
      
      // ゲストは登録された会社のみ
      let set_company = [];
      if( data.id == 'management_guest'  ) try { set_company = this.props.update.management_company.split(',').map((id) => { return parseInt(id); }); } catch(e) {}
      
      base.management.users.map((d) => {
        if( this.state.select_list.indexOf(d.id) >= 0 || skip_list.indexOf(d.id) >= 0 ) return;
        
        if( data.id == 'management_guest' ){
          if( d.is_guest == 1 && set_company.indexOf(d.guest_company_id) >= 0 ) targets.push(d);
        } else {
          if( d.is_guest == 0 ) targets.push(d);
        }
      });
    }
    return targets;
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let base = this.props.base;
    
    let select_list = this.state.select_list;
    
    // 選択済みデータ
    let ids = this.getDefaultValue.bind(this)();
    
    // 登録対象設定
    let targets = this.getTargets.bind(this)();
    
    return (
      <div className="input-management">
        
        <TargetAccounts base={base} data={data} targets={ids} update={this.props.update} notice_toggle={this.notice_toggle.bind(this)} action_client_toggle={this.action_client_toggle.bind(this)} />
        
        <p className="edit-button" onClick={this.openModal.bind(this)}>編集</p>
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {'calc(100% - 150px)'}
          height    = {'500px'}
          max_width = {700}
          close_ev  = {this.closeModal.bind(this)}
          html      = {(
            <div className="guest-select-modal-contents">
              
              <TargetAccounts base={base} data={data} targets={select_list} update={this.props.update} notice_toggle={this.notice_toggle.bind(this)} action_client_toggle={this.action_client_toggle.bind(this)} remove_ev={this.remove.bind(this)} />
              
              <h6>{data.name}の追加</h6>
              
              <div className="selectbox-forms">
                <div className="selectbox">
                  <select ref={(input) => { this.item = input }} onChange={this.change.bind(this)}>
                    { (targets.length > 0)
                      ? <option value="null">{data.name}を選択してください</option>
                      : <option value="null">登録できる対象が見つかりません</option>
                    }
                    
                    { targets.map((d, key) => {
                      return <option key={key} value={d.id}>{d.name}{(d.email != undefined) && ' ('+ d.email +')'}</option>
                    })}
                  </select>
                </div>
                
                { (this.state.select_id != null && this.state.select_id != 'null')
                  ? <p className="button" onClick={this.select.bind(this)}>追加</p>
                  : <p className="button off">追加</p>
                }
              </div>
              
              <p className="button complete" onClick={this.update.bind(this)}>保存</p>
              
            </div>
          )}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class TargetAccounts extends React.Component {
  render() {
    let data = this.props.data;
    let base = this.props.base;
    
    // オブジェクトデータ設定
    let managementObj = {};
    if( data.id == 'management_company' ){
      managementObj = Utils.createColumnObject(base.management.guest_companys, 'id');
    } else {
      managementObj = Utils.createColumnObject(base.management.users, 'id');
    }
    
    let targets = [];
    this.props.targets.map((id) => {
      if( managementObj[id] != undefined ) targets.push(managementObj[id]);
    });
    
    // アカウントが存在しない場合
    if( targets.length == 0 ) return <div className="management-targets"><p className="target-none">対象がありません</p></div>;
    
    return (
      <ul className="management-targets">
        { targets.map((target, key) => {
          
          // 通知設定
          let is_notice = false;
          try { if( this.props.update.notice.split(',').indexOf(String(target.id)) >= 0 ) is_notice = true; } catch(e) {}
          
          let notice_html = null;
          if( data.id == 'management_admin' || data.id == 'management_worker' ){
            let flg = (is_notice == true) ? 'on' : 'off';
            notice_html = <span className={'notice '+ flg} onClick={this.props.notice_toggle.bind(this, target.id)}>通知{flg.toUpperCase()}</span>
          }
          
          // クライアント通知設定
          let is_action_client = false;
          try { if( this.props.update.action_client.split(',').indexOf(String(target.id)) >= 0 ) is_action_client = true; } catch(e) {}
          
          let action_client_html = null;
          if( data.id == 'management_worker' ){
            let flg = (is_action_client == true) ? 'on' : 'off';
            action_client_html = <span className={'notice '+ flg} onClick={this.props.action_client_toggle.bind(this, target.id)}>クライアント連絡{flg.toUpperCase()}</span>
          }
          
          return (
            <li key={key}>
              <span className="no">{(key + 1)}</span>
              <div className="name">{target.name}{(target.email != undefined) && <span className="email">({target.email})</span>}</div>
              
              { (notice_html != null) &&
                <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>ONにするとタスクが発生する度に通知されます</Tooltip>}>
                  {notice_html}
                </OverlayTrigger>
              }
              
              { (action_client_html != null) &&
                <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>ONにするとタスクが発生する度に通知されます</Tooltip>}>
                  {action_client_html}
                </OverlayTrigger>
              }
              
              { (this.props.remove_ev != undefined) && <i className="material-icons" onClick={this.props.remove_ev.bind(this, target.id)}>close</i> }
            </li>
          );
        })}
      </ul>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputManagement;